import {API_URL} from '../config/entrypoint';
import {ajax} from 'rxjs/ajax';

export function saveFile(authToken: string, formData: FormData) {
    return ajax({
        url: `${API_URL}/api/media_objects`,
        method: 'POST',
        body: formData,
        headers: {
            Authorization: 'Bearer ' + authToken,
        },
    });
}
